<template>
	<div>
		<search></search>
		<div class="_content_ clearfix">
			<ul>
				<li :class="{active:item.isClick}" @click="gotoitem(item.id,index)" v-for="(item,index) in list" :key="index">{{item.name}}</li>
			</ul>
			<div v-show="!isShow" class="_item_">
				<p @click="gotodetails(item.id)" v-for="(item,index) in itemList" :key="index">{{item.title}}</p>
			</div>
			<div v-show="isShow" class="_details_">
				<div class="_details__title">
					<h2>{{orderData.title}}</h2>
					<div>{{orderData.dateCreated}}</div>
				</div>
				<div class="_details_details_"></div>
			</div>
		</div>
	</div>
	
</template>

<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,sha1,overtime } from '../../assets/js/public.js'
import Vue from 'vue'
import bus from '../../assets/js/eventBus'
import search from '@/components/index/search'
export default {
	inject:['reload'],
	components:{
		search
	},
	data () {
		return {
			list:[],
			itemList:[],
			isShow:false,
			h:'',
			orderData:{}
		}
	},
	mounted:function (){
		this.getList()
		if(this.$route.query.id){
			this.gotodetails(this.$route.query.id)
		}
	},
	methods : {
		gotodetails:function(id){
			this.isShow=true
			this.list.forEach(function(item,index){
				item.isClick=false
			},this)
			const url = `${ip}formWorkInterface/getArticeById`;
			let data = Qs.stringify({"channel":2,tamp:localStorage.tamp?localStorage.tamp:'',id:id});
			axios.post(url,data).then(res => {
				if(overtime(res.data.code)){
					localStorage.removeItem('tamp')
					localStorage.removeItem('name')
					return this.$router.push({
						path: '/LoginHome?state=1',
						query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
					});
					this.$router.go(0);
				}
				if(res.data.code==300){
					var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
					return window.open(href.href,'_blank')
				}
				if(res.data.code!=0)return
				this.orderData=res.data.rows
				this.h=res.data.rows.content
				$('._details_details_').html(this.h)
			})
		},
		gotoitem:function(id,idx){
			this.list.forEach(function(item,index){
				item.isClick=false
			},this)
			this.list[idx].isClick=true
			this.isShow=false
			const url = `${ip}formWorkInterface/getMallArticle`;
			let data = Qs.stringify({"channel":2,tamp:localStorage.tamp?localStorage.tamp:'',category:id,pagesize:10000,page:1});
			axios.post(url,data).then(res => {
				if(overtime(res.data.code)){
					localStorage.removeItem('tamp')
					localStorage.removeItem('name')
					return this.$router.push({
						path: '/LoginHome?state=1',
						query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
					});
					this.$router.go(0);
				}
				if(res.data.code==300){
					var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
					return window.open(href.href,'_blank')
				}
				if(res.data.code!=0)return
				this.itemList=res.data.rows.rows
			})
		},
		getList:function(){
			const url = `${ip}formWorkInterface/getArticleCategory`;
			let data = Qs.stringify({"channel":2,tamp:localStorage.tamp?localStorage.tamp:''});
			axios.post(url,data).then(res => {
				if(overtime(res.data.code)){
					localStorage.removeItem('tamp')
					localStorage.removeItem('name')
					return this.$router.push({
						path: '/LoginHome?state=1',
						query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
					});
					this.$router.go(0);
				}
				if(res.data.code==300){
					var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
					return window.open(href.href,'_blank')
				}
				if(res.data.code!=0)return
				res.data.rows.forEach(function(item,idx) {
					this.$set(item,'isClick', false)
				}, this);
				this.list=res.data.rows
				
					res.data.rows.forEach(function(item,idx) {
						if(this.$route.query._id==item.id){
							this.gotoitem(item.id,idx)
						}
					}, this);
				
			})
		}
	}
}
</script>
<style>
	.clearfix{
		overflow:auto;
		_zoom:1;
	}
	._content_{
		padding-top: 15px;
		width: 1200px;
		margin: 0 auto;
	}
	._content_ ul{
		width: 200px;
		float: left;
	}
	._content_ ul li{
		width: 198px;
		height: 34px;
		background: #f7f7f7;
		text-align: center;
		line-height: 34px;
		border: 1px solid #ebebeb;
		border-bottom: 1px dashed #ebebeb;
		cursor: pointer;
	}
	._content_ ul .active{
		background: #fff;
	}
	._item_{
		width: 910px;
		min-height: 500px;
		border: 1px solid #ebebeb;
		float: right;
		padding: 40px;
	}
	._content_ p{
		margin-bottom: 20px;
		cursor: pointer;
	}
	._details_{
		width: 970px;
		min-height: 500px;
		border: 1px solid #ebebeb;
		float: right;
		padding: 10px;
	}
	._details__title{
		margin-bottom: 20px;
	}
	._details__title h2{
		font-size:30px;
		text-align: center;
		margin-bottom: 20px;
	}
	._details__title div{
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/article/list.vue